import Companies from "./index.vue";
import Vue from "vue";
import {
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
} from "./types";
import { getUniversities } from "@/api";

export default Vue.extend<
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
>({
  data() {
    return {
      companies: [],
      universities: []
    };
  },
  methods: {
    pushCompanies(companies) {
      this.companies.push(...companies);
    },
    replaceCompanies(companies) {
      this.companies = companies;
    },
    resetCompanies() {
      this.companies = [];
    },
    async searchUniversity(keyword) {
      const { data } = await getUniversities({ name: keyword });
      this.universities = data.universities;
    },
    resetUniversities() {
      this.universities = [];
    }
  },
  render(createElement) {
    return createElement(Companies, {
      props: {
        companies: this.companies,
        universities: this.universities
      },
      on: {
        pushCompanies: this.pushCompanies,
        replaceCompanies: this.replaceCompanies,
        resetCompanies: this.resetCompanies,
        searchUniversity: this.searchUniversity,
        resetUniversities: this.resetUniversities
      }
    });
  }
});
